import { Component } from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/joy';

// Keep navigation available if a single section throws during rendering.
export default class RouteErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error, info) { console.error('Не удалось открыть раздел LunaDesk:', error, info.componentStack); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <Box sx={{ p: 2 }}><Alert color="danger" variant="soft"><Stack spacing={1}><Typography level="title-sm">Не удалось открыть раздел</Typography><Typography level="body-sm">Попробуйте ещё раз. Можно перейти в другой раздел через меню.</Typography><Button size="sm" variant="soft" color="danger" onClick={() => this.setState({ failed: false })}>Повторить открытие</Button></Stack></Alert></Box>;
  }
}
